<div class="d-grid gap-2">
    <button (click)="connectAccount()" class="btn btn-primary" type="button">connect account</button>
    <button (click)="logout()" class="btn btn-primary" type="button">disconnect</button>
</div>